// request.js
import UNI_APP from '@/utils/.env.js';

import axios from 'axios';
import queryString from 'query-string';

const baseURL = UNI_APP.BASE_URL || 'https://api.codepoworld.com'; // 替换为你的 API 基础路径

const http = axios.create({
  baseURL,
  timeout: 50000 // 15秒
});

// 用于存储正在处理的请求，防止重复请求
let cachcRequest = {};

function generateReqKey(config) {
  const { method, url, params, data } = config;
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&');
}

http.interceptors.request.use(
  (config) => {
    config.startTime = Date.now(); // 记录请求发送时间
    config.headers['x-terminal-type'] = 0;
    return config;
  },
  (config) => {
    return Promise.reject(config); // 请求失败时的处理
  }
);

http.interceptors.response.use(
  (response) => {
    // 重复请求拦截 - 请求成功删除缓存
    let reqKey = generateReqKey(response.config);
    delete cachcRequest[reqKey];

    if (response.status === 200) {
      const resData = response.data;
      if (resData.code === 1) {
        console.log('响应');
        return resData.data;
      } else {
        console.error(resData.errorMsg);
        return Promise.reject(resData.errorMsg);
      }
    }
  },
  (error) => {
    console.log('响应拦截器错误:', error);
    return Promise.reject(error);
  }
);

export function request(config) {
  return http(config);
}

export function post(url, data, custom = {}) {
  if (data) {
    data.zh_en = localStorage.getItem('zh_en') ? localStorage.getItem('zh_en') : 'zh'
  } else {
    data = { zh_en: localStorage.getItem('zh_en') ? localStorage.getItem('zh_en') : 'zh' }
  }
  console.log(data);
  return request({
    method: 'POST',
    url,
    data,
    custom
  });
}

export function get(url, params, custom = {}) {
  return request({
    method: 'GET',
    url,
    params,
    custom
  });
}

export function put(url, params) {
  return request({
    url,
    params,
    method: 'PUT'
  });
}

export function formData(method, url, data, custom = {}) {
  return request({
    method,
    url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: queryString.stringify(data),
    custom
  });
}